<template>
  <div>
    <div class="body" id="captureId">
      <div class="geren" @click="user">
        <div class="shezhi">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconfaxian" />
          </svg>
        </div>
        <div class="xinxi">
          <img
            :src="this.userInfo.avatar"
            alt
            v-show="imgshowa == 1"
            class="fl"
          />
          <img
            src="http://rjwpublic.oss-cn-qingdao.aliyuncs.com/album/space/dynamic1592536362816.jpg"
            alt
            v-show="imgshowa == 2"
            class="fl"
          />
          <div class="fl">
            <p>{{ userInfo.user_nicename }}</p>
            <p
              class="leavr"
              v-for="(item1, index) in userType"
              :key="index"
              v-show="item1.id == item.user_type"
            >
              {{ item1.identity }}
              <!-- <span>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconfaxian"></use>
                </svg>
              </span>-->
            </p>
          </div>
        </div>
      </div>

      <ul class="clear navtypeone">
        <li v-for="item in list_one" :key="item.ming" class="fl">
          <a :href="item.url">
            <svg class="icon" aria-hidden="true">
              <use :xlink:href="item.name" />
            </svg>
            <span>{{ item.ming }}</span>
          </a>
        </li>
      </ul>

      <div class="yaoqing" @click="yaoqing">
        <img src="@/assets/yapqing.png" alt />
      </div>

      <ul class="clear navtypeone">
        <van-divider
          :style="{
            color: '#1989fa',
            borderColor: '#1989fa',
            padding: '0 16px',
          }"
          >我的账户</van-divider
        >
        <li class="fl" @click="dian">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconicon-test1" />
          </svg>
          <span>金牌名师卡激活</span>
        </li>
        <li v-for="item in list_two" :key="item.ming" class="fl">
          <a :href="item.url">
            <svg class="icon" aria-hidden="true">
              <use :xlink:href="item.name" />
            </svg>
            <span>{{ item.ming }}</span>
          </a>
        </li>
      </ul>

      <ul class="clear navtypeone">
        <van-divider
          :style="{
            color: '#1989fa',
            borderColor: '#1989fa',
            padding: '0 16px',
          }"
          >我的服务</van-divider
        >
        <li v-for="item in list_three" :key="item.ming" class="fl">
          <a :href="item.url">
            <svg class="icon" aria-hidden="true">
              <use :xlink:href="item.name" />
            </svg>
            <span>{{ item.ming }}</span>
          </a>
        </li>
        <li class="fl" @click="gotwo" v-if="token">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconbangding" />
          </svg>
          <span>绑定学生</span>
        </li>
        <li class="fl" @click="handleclick" v-if="teacher">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconerweima2" />
          </svg>
          <span>班级二维码</span>
        </li>
        <li class="fl" @click="$router.push('/management')" v-if="teacher">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconapp-management" />
          </svg>
          <span>应用管理</span>
        </li>
        <li class="fl" @click="complaintclick">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icontousujubao" />
          </svg>
          <span>意见反馈</span>
        </li>
      </ul>
      <!-- 选择班级弹框 -->
      <van-popup v-model="isshow" position="bottom">
        <van-radio-group v-model="radio">
          <div style="font-size: 16px; text-align: center; padding: 13px 0">
            请选择班级
          </div>
          <van-field name="switch" label="是否需要审核">
            <template #right-icon>
              <van-switch
                v-model="switchChecked"
                size="20"
                @change="handleAudit"
              />
            </template>
          </van-field>
          <van-cell-group>
            <van-cell
              v-for="(item, index) in class_list"
              :key="index"
              :title="item.grade_name + item.class_name"
              clickable
              @click="handleRadio(item, index)"
            >
              <template #right-icon>
                <van-radio :name="item.class_id" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-popup>
      <!-- 二维码 弹出框 -->
      <van-popup v-model="iscode" style="border-radius: 3%">
        <div
          style="
            font-size: 18px;
            height: 51px;
            line-height: 51px;
            padding: 0 20px;
          "
        >
          <div style="float: left">进班二维码</div>
          <span style="float: right" @click="handleRefresh"
            >刷新 <van-icon style="font-size: 16px" name="replay"
          /></span>
        </div>
        <div style="border-bottom: 1px solid #aaaaaa; width: 100%"></div>
        <div
          id="qrCode"
          ref="qrCodeDiv"
          style="width: 270px; heigth: 300px; padding: 30px"
        ></div>
      </van-popup>

      <!-- <van-popup v-model="complaintshow" style="border-radius: 3%;">
        <div class="complaintbox clear" style="text-align:center;font-size: 0;">

          <div class="qiehuan fl" @click="complaintmobile('投诉')" :class="complaintshow_one == true?'actvie':''">投诉建议</div>
          <div class="qiehuan fr" @click="complaintmobile('注销')" :class="complaintshow_one == false?'actvie':''">注销账号</div>

          <textarea v-if="complaintshow_one" class="contenttext" rows="10" placeholder="请输入你的举报内容" v-model="complainttext"></textarea>
          <textarea v-else class="contenttext" rows="10" placeholder="请删除你的举报内容" v-model="complainttext"></textarea>

          <input v-show="complaintshow_one == true" class="shouji" v-model="complaintcellphone" type="text" placeholder="请输入手机号">

          <div class="button fr" @click="complaintbutton(1)">取消</div>
          <div class="button fr" @click="complaintbutton(2)">确定</div>
        </div>
      </van-popup> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import URL from "../api/index";
import VueEvent from "../model/VueEvent";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import {
  Cell,
  CellGroup,
  Icon,
  Button,
  Toast,
  Swipe,
  SwipeItem,
  Divider,
  Dialog,
  Switch,
  Overlay,
} from "vant";
Vue.use(Toast);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Divider);
Vue.use(Dialog);
Vue.use(Overlay);
Vue.use(Switch);
import axios from "axios";
export default {
  data() {
    return {
      complaintcellphone: "",
      complaintmobiledata: "投诉",
      complaintshow_one: true,
      complaintshow: false,
      complainttext: "",
      token: "",
      teacher: "",
      userInfo: "",
      item: "",
      Spaceid: "",
      imgshow: "",
      imgshowa: "1",
      nameval: "",
      money: "",
      radio: "",
      switchChecked: false,
      isshow: false,
      iscode: false,
      nowtime: "",
      student_code: "",
      class_list: [],
      cktype: 0,
      userType: [
        { id: "2", identity: "会员" },
        { id: "3", identity: "教师" },
        { id: "4", identity: "校长" },
        { id: "5", identity: "学生" },
        { id: "6", identity: "教育局" },
      ],
      list_one: [
        {
          name: "#iconjingdianyuedu",
          ming: "我的课程",
          url: "https://www.gankao.com/home/mycourse",
        },
        {
          name: "#iconwodedingdan",
          ming: "我的订单",
          url: "http://www.rujiaowang.net/sls/#/CourseOrder",
        },
        {
          name: "#iconxuexitongji",
          ming: "学习统计",
          url: "https://www.gankao.com/studyStatistic",
        },
        {
          name: "#iconshuati",
          ming: "我的刷题",
          url: "https://work.gankao.com/noAccess",
        },
      ],
      list_two: [
        {
          name: "#iconhuiyuanka",
          ming: "会员卡",
          url: "https://account.gankao.com/card",
        },
        {
          name: "#iconkapianjihuo",
          ming: "VIP会员激活",
          url: "https://account.gankao.com/jihuo",
        },
        // {name:'#iconicon-test1', ming:'金牌名师卡激活',url:'https://account.gankao.com/jihuo'}
      ],
      list_three: [
        {
          name: "#iconshoucang",
          ming: "我的收藏",
          url: "https://www.gankao.com/home/collect",
        },
        {
          name: "#iconwodepingce",
          ming: "我的评测",
          url: "https://www.gankao.com/home/ceping",
        },

        {
          name: "#iconbanjizuoye1",
          ming: "我的作业",
          url:
            localStorage.getItem("userInfo") == null
              ? "https://www.rujiaowang.net/mobile/#/login"
              : "http://www.rujiaowang.net/app/zuoye/student/index.html#/?token=" +
                JSON.parse(localStorage.getItem("userInfo")).token,
        },

        {
          name: "#iconyidongduanicon_cuotibensel",
          ming: "我的错题本",
          url: "http://tiku.gankao.com/worngquestion_subject",
        },
        {
          name: "#iconwenjianjia",
          ming: "我的资料夹",
          url: "https://ziliao.gankao.com/pc/database",
        },
        // { name: "#iconerweima2", ming: "班级二维码", url: "#" },
        // { name: "#icontousujubao", ming: "投诉举报", url: "#" },
      ],
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (this.userInfo.level == "家长") {
      this.token = true;
    } else {
      this.token = false;
    }
    if (this.userInfo.level == "教师") {
      this.teacher = true;
    } else {
      this.teacher = false;
    }
    this.getTime();
    // 接收传过来的用户的信息
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.imgshow = this.userInfo.avatar;
      if (this.imgshow == "" || this.imgshow == " ") {
        this.imgshowa = 2;
      } else {
        this.imgshowa = 1;
      }
    }
    this.getuser();
    this.userspace();
    // VueEvent.$emit('id',)
  },
  methods: {
    gotwo() {
      this.$router.push({ path: "/bangdingjiazhang" });
    },
    handleAudit(res) {
      console.log(res);
      if (res == true) {
        this.cktype = 1;
      } else {
        this.cktype = 0;
      }
    },
    // 单选之后 弹出二维码
    handleRadio(item, index) {
      this.radio = item.class_id;
      this.student_code = item.student_code;
      window.setTimeout(() => {
        this.isshow = false;
        this.iscode = true;
        this.getcode();
      }, 100);
    },
    // 刷新二维码
    handleRefresh() {
      this.$axios({
        method: "get",
        url: URL.gettime,
      }).then((res) => {
        this.nowtime = res.data.result.stimestamp;
        console.log(this.nowtime);
        this.getcode();
      });
    },
    // 生成二维码
    getcode() {
      if (document.getElementById("qrCode")) {
        document.getElementById("qrCode").innerHTML = ""; // 清除上一个二维码
      }
      var codeContent = JSON.stringify({
        purpose: "studentJoinClass",
        url: "http://api.rujiaowang.net/api/classc/joinclass",
        method: "POST",
        date: {
          code: this.student_code,
          timestamp: this.nowtime,
          cktype: this.cktype,
        },
      });
      // 延后 生成二维码
      this.$nextTick(() => {
        new QRCode(this.$refs.qrCodeDiv, {
          text: codeContent,
          width: 260,
          height: 260,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.Q,
        });
      });
      html2canvas(document.querySelector("#captureId"), {
        allowTaint: true,
        useCORS: true,
      }).then((canvas) => {
        let imgUrl = canvas.toDataURL("image/png");
        this.dataURL = imgUrl;
        this.firstFlag = false;
      });
    },
    // 获取时间戳
    getTime() {
      this.$axios({
        method: "get",
        url: URL.gettime,
      }).then((res) => {
        this.nowtime = res.data.result.stimestamp;
        // console.log(this.nowtime);
      });
    },
    // 点击班级二维码
    handleclick() {
      // if (item.ming == "班级二维码") {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$axios({
        method: "post",
        url: URL.getclasslist,
        data: {
          token: userInfo.token,
        },
      }).then((res) => {
        console.log(res.data.result);
        if (res.data.state == 1) {
          Toast("您没有权限生成班级二维码！");
          return false;
        }
        this.class_list = res.data.result;
        this.isshow = true; //出现班级选择弹框
        this.getTime();
      });
      // }
    },
    // 投诉举报弹出框
    complaintclick() {
      // this.complaintshow = true
      window.location.href = "http://portal.rujiaowang.net/portal/index/tousu";
    },
    // 投诉举报
    // complaintbutton(e){
    //   if(e == 1){
    //     this.complaintshow = false
    //   } else{
    //     this.complaintshow = false
    //     this.$axios({
    //       method: "post",
    //       url: URL.feedback,
    //       data:{content:this.complainttext}
    //     }).then((res) => {
    //       Toast(res.data.msg);
    //     });
    //   }
    // },
    dian() {
      Toast({
        message:
          "孺教网电脑端微课资源丰富，请用电脑登录进入个人中心激活并使用！",
        duration: 6000,
      });
    },
    dian2() {
      Toast("账户剩余 " + this.money.money + "R点");
    },
    user() {
      this.$router.push({ path: "/UserData" });
    },
    go_a() {
      this.$router.push({ path: "/CourseOrder" });
    },
    yaoqing() {
      if (localStorage.getItem("userInfo")) {
        console.log(localStorage.getItem("userInfo"));
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      }
      this.$router.push({
        name: "generalize",
        query: {
          userId: this.userInfo.user_id,
          name: this.userInfo.user_nicename,
          avatar: this.userInfo.avatar,
        },
      });
    },

    //  获取用户信息 api.rujiaowang.net/api/user/get_user
    getuser() {
      this.$http
        .post("api/user/get_user", {
          token: this.userInfo.token,
        })
        .then((item) => {
          this.money = item.data.result;
          this.item = item.data.result;
        });
    },

    // 查询制定用户的空间   http://api.rujiaowang.net/netlearn/space/getUserspace
    userspace() {
      this.$http
        .post("/netlearn/space/getUserspace", {
          token: this.userInfo.token,
          // user_id: this.Userid
        })
        .then((item) => {
          this.userspacelist = item.data.result;
          if (item.data.state == 0) {
            for (var i = 0; i < this.userspacelist.length; i++) {
              if (this.userspacelist[i].space_type.substring(0, 2) == "01") {
                //没有01开头的空间则不显示班级圈，学校圈
                let routerstate = "1";
                localStorage.setItem(
                  "routerstate",
                  JSON.stringify(routerstate)
                );
              }
              if (this.userspacelist[i].space_id == 0) {
                //如果用户登录完成没有查找到spaceid 则走申请空间方法 有空间id走自己空间方法
              } else {
                if (this.userspacelist[i].space_type == "0001") {
                  //如果是个人空间
                  this.Spaceid = this.userspacelist[i].space_id;
                  // window.location.href = " http://www.rujiaowang.net/app/netspace/dynamic.html?token="+this.userInfo.token+"&spaceid="+this.Spaceid+"&userid="+this.userInfo.user_id;
                } else {
                }
              }
            }
          } else {
            //没有信息跳转申请空间
            this.establish();
            // this.$message.error(item.data.msg)
          }
        });
    },
    establish() {
      //    创建空间 http://api.rujiaowang.net/netlearn/space/createSpace
      this.$http
        .post("/netlearn/space/createSpace", {
          token: this.userInfo.token,
          space_type: "0001",
          space_name: this.userInfo.user_nicename,
        })
        .then((item) => {
          if (item.data.state === 0) {
            let getSpaceinfo = item.data.result;
            localStorage.setItem("getSpaceinfo", JSON.stringify(getSpaceinfo));
            window.location.href =
              " http://www.rujiaowang.net/app/netspace/dynamic.html?token=" +
              this.userInfo.token +
              "&spaceid=" +
              this.Spaceid +
              "&userid=" +
              this.userInfo.user_id;
          } else {
          }
        });
    },
  },
};
</script>


<style scoped>
.body {
  padding: 10px 15px 80px;
}

.geren {
  position: relative;
  min-height: 80px;
  background-color: #fff;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.shezhi {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: #fff;
  box-shadow: #2d49a6 0px 0px 10px;
}
.shezhi .icon {
  font-size: 20px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.geren .xinxi {
  width: 90%;
  position: absolute;
  left: 10px;
  bottom: 10px;
}
.geren .xinxi img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 10px;
}
.geren .xinxi p:first-child {
  width: 10em;
  line-height: 30px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.geren .xinxi .leavr {
  line-height: 28px;
  font-size: 14px;
}
.navtypeone {
  margin-top: 5px;
  width: 100%;
}
.navtypeone p {
  margin-top: 20px;
  font-size: 14px;
}
.navtypeone li {
  width: 25%;
  text-align: center;
  margin-top: 8px;
}
.navtypeone li .icon {
  font-size: 32px;
  color: #4e8df6;
}
.navtypeone li span {
  display: block;
  font-size: 0.32rem;
  text-align: center;
  margin-top: 7px;
}
.navtypeone:last-child {
  margin-bottom: 20px;
}
.yaoqing {
  width: 100%;
  margin: 20px 0 0;
}
.yaoqing img {
  width: 100%;
}
.complaintbox {
  background-color: #fff;
  /* height: 180px; */
  width: 260px;
  padding: 20px;
  overflow: hidden;
}
.contenttext {
  font-size: 12px;
  width: 100%;
}
.button {
  font-size: 14px;
  text-align: center;
  width: 4em;
  line-height: 24px;
  margin: 10px;
  border-radius: 5px;
  background-color: #4e8df6;
  color: #fff;
}
.qiehuan {
  font-size: 14px;
  text-align: center;
  padding: 0 5px;
  line-height: 24px;
  margin: 10px;
  border-radius: 5px;
  background-color: #eee;
}
.actvie {
  background-color: #4e8df6;
  color: #fff;
}
.shouji {
  width: 100%;
  font-size: 12px;
  line-height: 30px;
  text-indent: 1em;
  margin-top: 5px;
}

input,
textarea {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/userInfo.vue